import { ApplicationRoutes } from '../../../app-routes-names'

export const ReportsRoutes = {
  sales: 'sales',
  grossprofit: 'gross-profit',
  labors: 'labor-tracker'
}

const { reports } = ApplicationRoutes

export const ReportsPaths = {
  sales: `/${reports}/${ReportsRoutes.sales}`,
  grossprofit: `/${reports}/${ReportsRoutes.grossprofit}`,
  labors: `/${reports}/${ReportsRoutes.labors}`
}
